import { useSubWorkspacesQuery } from '../../../../../../components/FilterManager/WorkspaceFilter/graphql/queries/generated/subWorkspaces';

export default function useSubworkspaces() {
  const [{ data, fetching, error }] = useSubWorkspacesQuery();

  return {
    subWorkspaces: data?.subWorkspaces,
    fetching,
    error,
  };
}
